export const stringifyPrice = (value: number, precision: number, language: string): string =>
  value.toLocaleString(language, {
    style: 'currency',
    currency: 'eur',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  });
